import store from 'store';

import { useStore, Store } from './store';

export function storageGet<T>(key: string, defaultValue?: T): T {
    return store.get(key, defaultValue);
}

export function storageSet(key: string, value: unknown) {
    store.set(key, value);
}

export function storageRemove(key: string) {
    store.remove(key);
}

export function useStorage<T>(store: Store<T>, key: string): [T, (value: T) => void] {
    const [get, set] = useStore(store);

    function setValue(value: T) {
        if (value) {
            storageSet(key, value);
        } else {
            storageRemove(key);
        }

        set(value);
    }

    return [get, setValue];
}
